var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadsAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m722.31,460.84c0,82.79 -67.21,150 -150,150c-82.79,0 -150,-67.21 -150,-150c0,-82.79 67.21,-150 150,-150c82.79,0 150,67.21 150,150z",
    id: "l1GUpXHNAn"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 412,
    height: 412,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "shadow1282490",
    x: 311.31,
    y: 199.84,
    width: 523,
    height: 523,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "m350.000002,200.000004c0,82.79 -67.21,150 -150,150c-82.79,0 -150,-67.21 -150,-150c0,-82.79 67.21,-150 150,-150c82.79,0 150,67.21 150,150z",
    id: "bzZh5CZiO",
    fill: "white",
    filter: "url(#shadow1282490)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1GUpXHNAn",
    fill: "#8f2d56",
    id: "svg_4",
    y: -260.839996,
    x: -372.309998
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1GUpXHNAn",
    fillOpacity: 0,
    stroke: "#8f2d56",
    strokeWidth: 90,
    strokeOpacity: 0.67,
    id: "svg_6",
    y: -260.839996,
    x: -372.309998
  })))), /*#__PURE__*/React.createElement("text", {
    stroke: "#000",
    transform: "matrix(7.680335521697998,0,0,7.609161853790282,-1084.931969165802,-1151.3818813785908) ",
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_33",
    y: 185.853628,
    x: 160.171824,
    strokeWidth: 0,
    fill: "#ffffff"
  }, "L"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadsAvailable);
export default __webpack_public_path__ + "static/media/LoadsAvailable.f9fb127296f6458fed69ab0e5ffc6f48.svg";
export { ForwardRef as ReactComponent };